import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDeceasedCmConstants {
    static STEP_TITLE = "Deceased";
    static DECEASED_DETAILS_LABEL = "Deceased details";
    static CAPTURE_DECEASED_DETAILS_LABEL = "Please capture the name, surname and date when it was changed";
    static SEX_LABEL = "Sex";
    static NATIONALITY_LABEL = "Nationality";
    static IDENTIFICATION_TYPE_LABEL = "Identification type";
    static ID_NUMBER_LABEL = "Id / passport number";
    static DATE_OF_BIRTH_LABEL = "Date Of birth";
    static DATE_OF_DEATH_LABEL = "Date Of death";
    static PLACE_OF_BIRTH_LABEL = "Place of birth";
    static PLACE_OF_DEATH_LABEL = "Place of death";
    static MAIDEN_NAME_LABEL = "Maiden name";
    static PROVINCE_OF_DEATH_LABEL = "Province of death";
    static BURIAL_ORDER_NUMBER_LABEL = "Burial order number";
    static SERIAL_NUMBER_LABEL = "Serial number";
    static VERTICAL_POSITION_LABEL = "Vertical position (m)";
    static NAME_OF_UNDERTAKER_LABEL = "Name of undertaker (if funeral parlour does not exist)";
    static NAME_LABEL = "Name";
    static SURNAME_LABEL = "Surname";
    static START_DATE_LABEL = "Date name and surname given / date changed";
    static SEX_FORM_CONTROL_NAME = "sex";
    static NATIONALITY_FORM_CONTROL_NAME = "nationality";
    static IDENTIFICATION_TYPE_FORM_CONTROL_NAME = "identificationType";
    static ID_NUMBER_FORM_CONTROL_NAME = "idNumber";
    static DATE_OF_BIRTH_FORM_CONTROL_NAME = "dateOfBirth";
    static DATE_OF_DEATH_FORM_CONTROL_NAME = "dateOfDeath";
    static PLACE_OF_BIRTH_FORM_CONTROL_NAME = "placeOfBirth";
    static PLACE_OF_DEATH_FORM_CONTROL_NAME = "placeOfDeath";
    static MAIDEN_NAME_FORM_CONTROL_NAME = "maidenName";
    static PROVINCE_OF_DEATH_FORM_CONTROL_NAME = "provinceOfDeath";
    static BURIAL_ORDER_NUMBER_FORM_CONTROL_NAME = "burialOrderNumber";
    static SERIAL_NUMBER_FORM_CONTROL_NAME = "serialNumber";
    static VERTICAL_POSITION_FORM_CONTROL_NAME = "verticalPosition";
    static NAME_OF_UNDERTAKER_FORM_CONTROL_NAME = "nameOfUndertaker";
    static NAME_FORM_CONTROL_NAME = "name";
    static SURNAME_FORM_CONTROL_NAME = "surname";
    static START_DATE_FORM_CONTROL_NAME = "startDate";
    static VALIDATION_MESSAGES = {
        sex: {
            required: `Sex ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nationality: {
            required: `Nationality ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        identificationType: {
            required: `Identification type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        idNumber: {
            required: `Id number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        dateOfBirth: {
            required: `Date of birth ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        dateOfDeath: {
            required: `Date of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        placeOfBirth: {
            required: `Place of birth ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        placeOfDeath: {
            required: `Place of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        maidenName: {
            required: `Maiden name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        provinceOfDeath: {
            required: `Province of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        burialOrderNumber: {
            required: `Burial order number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        serialNumber: {
            required: `Serial number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        verticalPosition: {
            required: `Vertical position ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nameOfUndertaker: {
            required: `Name of undertaker ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        name: {
            required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        surname: {
            required: `Surname ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        startDate: {
            required: `Date name and surname given / date changed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
